export const defaultRegistrationClassification = [];

export const defaultRegistrations = [{}];

export const defaultRegistrationData = {
    allowEarlyFormSubmissionRegistrationPage: false,
    allowEarlyFormSubmissionStorePage: false,
    // TODO: currently using a function in registrationReducer to determine IS
    classification: defaultRegistrationClassification,
    currentRegistration: 0,
    currentRegistrationCategory: [],
    payment: {},
    promoCodes: [],
    promoDiscounts: {},
    // TODO: currently using a function in registrationReducer to determine IS
    registrations: defaultRegistrations,
    totals: {
        giftAssistAmount: 0.0,
        giftsSubtotalAmount: 0.0,
        optionalDonationAmount: 0.0,
        prePromoRegistrantTotal: 0.0,
        prePromoTransTotal: 0.0,
        registrantSubtotal: 0.0,
        shippingMethodAmount: 0.0,
        storeTaxAmount: 0.0,
        storeSubtotalAmount: 0.0,
        total: 0.0,
    },
    storeCart: [],
    giftAssist: false,
    addAdditionalParticipantDisabled: false,
};

export const defaultCalendarData = {
    address: "123 Qgiv St",
    city: "Orlando",
    // Leave the default start date empty to enable the placeholder
    // component to render in CMS, when applicable
    e_date_begin: "",
    e_date_end: "12/1/2050",
    e_time_begin: "10:00:00",
    e_time_end: "12:00:00",
    description: "Join us for an example event!",
    name: "Example Fundraiser",
    state: "FL",
    timezone: 1,
    zip: "32801",
};
